import { createPopper } from '@popperjs/core';
export function withPopper(dropdownList, component, { width }) {
  /**
   * We need to explicitly define the dropdown width since
   * it is usually inherited from the parent with CSS.
   */
  dropdownList.style.width = width;

  /**
   * Here we position the dropdownList relative to the $refs.toggle Element.
   *
   * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
   * the dropdownList overlap by 1 pixel.
   *
   * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
   * wrapper so that we can set some styles for when the dropdown is placed
   * above.
   */
  const popper = createPopper(component.$refs.toggle, dropdownList, {
    placement: this.placement || 'bottom',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, -1],
        },
      },
      {
        name: 'toggleClass',
        enabled: true,
        phase: 'write',
        fn({ state }) {
          component.$el.classList.toggle(
            'drop-up',
            state.placement === 'top'
          );
        },
      },
    ],
  });

  /**
   * To prevent memory leaks Popper needs to be destroyed.
   * If you return function, it will be called just before dropdown is removed from DOM.
   */
  return () => popper.destroy();
}
export function dateFormat(date) {
  const format = (d) => {
    if (!(d instanceof Date)) return '';

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  };

  if (Array.isArray(date)) {
    const [start, end] = date;

    const s = start instanceof Date ? format(start) : '';
    const e = end instanceof Date ? format(end) : '';

    if (s && e) return `${s} — ${e}`;
    if (s) return s;
    if (e) return e;

    return '';
  }

  return date instanceof Date ? format(date) : '';
}

export function splitDateTimeObj(d) {
  if (!(d instanceof Date)) {
    if (typeof d === 'string') {
      const iso = d.includes(' ')
        ? d.replace(' ', 'T')
        : d;

      d = new Date(iso);
    }
  }

  if (!(d instanceof Date) || isNaN(d.getTime())) {
    return { date: '', time: '' };
  }

  const pad = n => String(n).padStart(2, '0');

  return {
    date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
    time: `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`,
  };
}
